import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AdapterService } from './adapter.service';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  userInfo: any = {};
  loggedInUser: any = "";
  imageUrl = "";
  isIframe = false;


  constructor(private _adaptersService: AdapterService,
    public _notificationService: NotificationService,
    public _authService: AuthService,
    private router: Router) {
    this.imageUrl = this._authService.getLoggedInUser()?.imageUrl;
    this.isIframe = typeof window !== 'undefined' && window.self !== window.top;
    console.log(window.self,window.top, "isIframe", this.isIframe);
  }

  setLoginName() {
    if (this.userInfo)
      this.loggedInUser = `${this.userInfo.firstName}`;
  }
  logout() {
    this._authService.logout();
    this._notificationService.getServerCount();

    this.router.navigate(["/auth/login"]);
  }
}
